/**
 * src/components/ui/Button.jsx
 * Botón base con variantes y estados.
 */

const VARIANTS = {
  primary: {
    background: 'var(--color-accent)',
    color: 'var(--color-on-accent)',
    border: '1px solid transparent',
    hover: 'var(--color-accent-2)',
  },
  secondary: {
    background: 'var(--color-surface-2)',
    color: 'var(--color-text)',
    border: '1px solid var(--color-border)',
    hover: 'var(--color-border)',
  },
  danger: {
    background: 'var(--color-error-soft)',
    color: 'var(--color-error)',
    border: '1px solid var(--color-error-line)',
    hover: 'var(--color-error-hover)',
  },
  ghost: {
    background: 'transparent',
    color: 'var(--color-text-2)',
    border: '1px solid transparent',
    hover: 'var(--color-surface-2)',
  },
}

const SIZES = {
  sm: { padding: 'var(--space-1) var(--space-3)',  fontSize: 'var(--text-sm)',   borderRadius: 'var(--radius-sm)' },
  md: { padding: 'var(--space-2) var(--space-4)',  fontSize: 'var(--text-base)', borderRadius: 'var(--radius-md)' },
  lg: { padding: 'var(--space-3) var(--space-5)',  fontSize: 'var(--text-md)',   borderRadius: 'var(--radius-md)' },
}

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  icon = null,
  fullWidth = false,
  onClick,
  type = 'button',
  style: extraStyle = {},
}) {
  const v = VARIANTS[variant] || VARIANTS.primary
  const s = SIZES[size] || SIZES.md
  const isDisabled = disabled || loading

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--space-2)',
        background: v.background,
        color: v.color,
        border: v.border,
        borderRadius: s.borderRadius,
        padding: s.padding,
        fontSize: s.fontSize,
        fontWeight: 'var(--weight-medium)',
        fontFamily: 'var(--font-ui)',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.55 : 1,
        transition: 'all var(--t-base) var(--ease)',
        width: fullWidth ? '100%' : 'auto',
        whiteSpace: 'nowrap',
        letterSpacing: '0.01em',
        ...extraStyle,
      }}
      onMouseEnter={e => {
        if (!isDisabled) e.currentTarget.style.background = v.hover
      }}
      onMouseLeave={e => {
        if (!isDisabled) e.currentTarget.style.background = v.background
      }}
    >
      {loading ? (
        <span style={{
          width: '13px', height: '13px',
          border: '2px solid currentColor',
          borderTopColor: 'transparent',
          borderRadius: 'var(--radius-pill)',
          display: 'inline-block',
          animation: 'spin 0.7s linear infinite',
        }} />
      ) : icon}
      {children}
    </button>
  )
}
